export default () => {
  const createFallbackModule = (id, from) => {
    const isTranslation = id.includes('/translations');

    // Translation imports: return empty object so Object.entries() iterates safely
    if (isTranslation) {
      const emptyTranslations = {};
      if (from === 'build') {
        return () => ({ __esModule: true, default: emptyTranslations });
      }
      return { default: emptyTranslations };
    }

    // Component imports: return a React component that renders null
    // Works with React.lazy + Suspense; existing ErrorPage/ErrorBoundaryEmpty wrappers serve as safety net
    const FallbackComponent = () => null;
    FallbackComponent.displayName = `OfflineRemote(${id})`;

    if (from === 'build') {
      return () => ({ __esModule: true, default: FallbackComponent });
    }
    return { default: FallbackComponent };
  };

  return {
    name: 'offline-remote-plugin',
    errorLoadRemote({ id, error, from }) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(`[Module Federation] Remote "${id}" is offline:`, error);
      }
      return createFallbackModule(id, from);
    },
  };
};
